import dayjs from 'dayjs';

export function truncateString(str, num) {
  if (!str) {
    return '';
  }

  if (str.length <= num) {
    return str;
  }
  return `${str.slice(0, num)}...`;
}

export function isPDF(fileName) {
  return fileName.includes('.pdf');
}

export function isUrl(text) {
  const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
  return urlRegex.test(text);
}

export function isEmail(text) {
  const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return pattern.test(text);
}

export function debounce(fn, delay) {
  let timeoutID = null;

  return function () {
    clearTimeout(timeoutID);

    const args = arguments;
    const that = this;

    timeoutID = setTimeout(function () {
      fn.apply(that, args);
    }, delay);
  };
}

export function addToDate(date, format, count = 10, parameter = 'days') {
  return date.add(count, parameter).format(format);
}

export function sortValue(key) {
  return (a, b) => a[key] - b[key];
}

// FIX: returns false if value is 0
export function checkValue(value) {
  return value || '---';
}

export function checkField(record) {
  return record || 'Нет данных';
}

export function boolToText(value) {
  return value ? 'Да' : 'Нет';
}

export const numToBoolText = {
  0: 'Нет',
  1: 'Да',
};

export const fullWidthStyle = { width: '100%' };

export function mapRegions(regions) {
  return regions?.map((region) => ({
    name: region.parent
      ? `${region.parent.name_rus}, ${region.name_rus}`
      : region.name_rus,
    id: region.id,
  }));
}

export function formatDate(date, format = 'DD.MM.YYYY') {
  return dayjs(date).format(format);
}

export function isNomenclaturesValid(nomenclatures, isPowerAttorney = false) {
  return (
    nomenclatures.length > 0 &&
    nomenclatures.every((nomenclature) => {
      if (isPowerAttorney) {
        return (
          nomenclature.name && nomenclature.measure_code && nomenclature.count
        );
      }

      return (
        nomenclature.name &&
        nomenclature.measure_code &&
        nomenclature.rate &&
        nomenclature.count &&
        nomenclature.amount
      );
    })
  );
}

export function parseJSONArray(data) {
  if (!data) {
    return null;
  }

  return JSON.parse(data?.slice(1, data.length - 1));
}

export const getDisabledDates = (disableDate) => (currentDate) => {
  return currentDate && currentDate < dayjs(disableDate);
};
